import {Avatar, Box, Flex, Heading, Icon} from "@chakra-ui/react";
import React, {useEffect, useState} from "react"
import {getFullUrlFromTagTypeAndUrl, getTagInfoFromTagId, getUrlImgFromTagId} from "../../tag/tools";
import {LOG} from "../../tools";
import {motion} from "framer-motion";
import {SColorBG} from "../../../gatsby-plugin-theme-ui-old";
import Link from "gatsby-link";
import {ChevronRightIcon} from "@chakra-ui/icons";
const MotionBox = motion(Box)
const MotionFlex = motion(Flex)
const MotionAvatar = motion(Avatar)
const PartiCardItem = ({tagId})=>{



    const [isHover,setIsHover] = useState(false)
    const tagInfo = getTagInfoFromTagId(tagId)
    LOG("tagInfo",tagInfo)
    const name = tagInfo["n"]
    const tag_type = tagInfo["t"]
    const tag_url = tagInfo["url"]
    const full_url = getFullUrlFromTagTypeAndUrl(tag_type,tag_url)
        const urlImg =  getUrlImgFromTagId(tagId,50)
    return <Link to={ full_url }><MotionFlex
        sx={{bg:'bg700',maxWidth:'200px',justifyContent:'space-between',alignItems:'center',
            m:'8px',borderRadius:'5px',
            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px'}}
            onMouseEnter={()=>setIsHover(true)} onMouseLeave={()=>setIsHover(false)}
                animate={isHover?"hover":"default"}
                    variants={{hover:{backgroundColor:SColorBG[900]},default:{backgroundColor:SColorBG[300]} }}
    >
            <MotionAvatar src={urlImg}   m={1}    variants={{hover:{filter:'grayscale(50%)'},default:{filter:'grayscale(100%)'} }}
                                                width={50} p={0}/>
            <Heading as={"h3"} size={"sm"} maxWidth={"145px"} m={1} p={1}>{name}</Heading>
        <MotionBox
        variants={{hover:{opacity: '100%', x: 0},
                default:{opacity: 0, x: -10} }}
                       >
          <Icon color={'text.300'} w={5} h={5} as={ChevronRightIcon} />
        </MotionBox>
    </MotionFlex></Link>

}

export default PartiCardItem